import type { PaletteOptions } from "@mui/material";
import { colors } from "./colors";

export const darkPalette: Readonly<Omit<PaletteOptions, "mode">> = {
  common: {
    black: colors.black,
    white: colors.white,
  },
  primary: {
    main: colors.emerald[500],
    dark: colors.emerald[700],
    light: colors.emerald[300],
    contrastText: colors.white,
  },
  secondary: {
    main: colors.white,
    dark: colors.gray[600],
    light: colors.gray[400],
    contrastText: colors.black,
  },
  error: {
    main: colors.red[500],
    dark: colors.red[600],
    light: colors.red[400],
    contrastText: colors.white,
  },
  warning: {
    main: colors.orange[500],
    dark: colors.orange[600],
    light: colors.orange[400],
    contrastText: colors.white,
  },
  info: {
    main: colors.sky[500],
    dark: colors.sky[600],
    light: colors.sky[400],
    contrastText: colors.white,
  },
  success: {
    main: colors.green[500],
    dark: colors.green[600],
    light: colors.green[400],
    contrastText: colors.white,
  },
  text: {
    primary: colors.white,
    secondary: colors.gray[400],
    disabled: colors.gray[200],
  },
  branding: {
    main: colors.branding[500],
    dark: colors.branding[600],
    light: colors.branding[400],
    contrastText: colors.white,
  },
  divider: colors.gray[500],
  background: {
    default: colors.background[800],
    paper: colors.background[700],
  },
  action: {
    active: colors.white,
  },
  custom: {
    activeButton: colors.gray[400],
    inputBorder: colors.borders[500],
    inputColor: colors.gray[400],
    inputLabelColor: colors.gray[400],
    dividerDrawer: colors.background[700],
  },
};
